import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RoomRule } from '@spike/room-model';
import clsx from 'clsx';
import DescriptionText from 'components/UI/V3/DescriptionText';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import NumberField from 'components/UI/V3/Forms/NumberField';
import { FunctionComponent } from 'react';
import styles from './WeightRule.module.scss';

interface WeightRuleProps {
    rule: RoomRule;
    onChange: (rule: RoomRule) => void;
    onDelete?: () => void;
    className?: string;
    error?: string;
}

export const WeightRule: FunctionComponent<WeightRuleProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.row}>
                <Label>Rule – By Total Pet Weight</Label>
                <FontAwesomeIcon
                    icon={faTrashAlt}
                    onClick={props.onDelete}
                    className={styles.deleteIcon}
                />
            </div>
            <DescriptionText
                className={styles.description}
                text="Set a maximum combined weight limit for all pets in the room at one time."
            />
            <Label className={styles.weightLabel}>Maximum Weight</Label>
            <div className={styles.weight}>
                <NumberField
                    endIcon={<span className={styles.lbs}>Lbs</span>}
                    value={JSON.parse(props.rule.data).totalWeight}
                    onChange={value =>
                        props.onChange({
                            ...props.rule,
                            data: JSON.stringify({ ...JSON.parse(props.rule.data), totalWeight: value })
                        })
                    }
                    placeholder="Ex. 120"
                    precision={4}
                />
            </div>
            {props.error && <span className={styles.errorWarning}>{props.error}</span>}
        </div>
    );
};

export default WeightRule;
